<template>
    <div class="grupo-de-botaos">
        <button
            v-for="(opcao, index) in opcoes"
            :key="index"
            @click="selecionarOpcao(opcao.valor)"
            class="botao"
            :class="{ 'botao-selecionado': opcao.valor === valor }"
        >
            <span v-if="opcao.icone" class="material-symbols-outlined icone" style="font-size: 17px">{{ opcao.icone }}</span>
            {{ opcao.rotulo }}
        </button>
    </div>
</template>

<script setup>
import { defineProps, defineEmits, computed } from 'vue';

const props = defineProps({
    opcoes: {
        type: Array,
        required: true,
    },
    modelValue: {
        type: String,
        default: '',
    },
});

const emit = defineEmits(['update:modelValue']);

const valor = computed({
    get: () => props.modelValue,
    set: (novoValor) => {
        if (novoValor === props.modelValue) {
            emit('update:modelValue', null);
            return;
        }

        emit('update:modelValue', novoValor);
    },
});

const selecionarOpcao = (opcao) => {
    valor.value = opcao;
};
</script>

<style scoped lang="scss">
.grupo-de-botaos {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .botao {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: start;
        gap: 8px;

        font-weight: 500;
        color: #252529;

        background: #fff;
        border: 1px solid #ccc;
        border-radius: 4px;
        cursor: pointer;
        font-size: 14px;
        font-weight: normal;
        line-height: 1.5;
        padding: 8px 16px 8px 12px;
        transition: all 0.2s ease;

        .icone {
            color: var(--primary-color);
        }

        &:hover {
            background: #f8f9fa;
            border-color: #0f97c7;
            color: #0f97c7;
        }

        &:focus {
            box-shadow: 0 0 0 0.2rem #91dcf7;
            outline: none;
        }

        &.botao-selecionado {
            background: #0f97c7;
            border-color: #0f97c7;
            color: #fff;

            .icone {
                color: #fff;
            }
        }
    }
}
</style>
